import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import locale from "element-plus/es/locale/lang/zh-cn";
import throttleDirective from "./utils/limitClick";
import "element-plus/dist/index.css";
import dayjs from "dayjs";
import mitt from "mitt";
const app = createApp(App);
app.config.globalProperties.$date = dayjs;
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}
app.directive("throttle", throttleDirective);
app.use(store);
app.use(router);
app.config.globalProperties.$mitt = mitt()
app.use(ElementPlus, { locale });
app.mount("#app");
